/* eslint-disable no-template-curly-in-string */
var englishTranslation = {
    translation: {
        button: {
            backToAccountManager: 'Back to account manager'
        },
        labels: {
            title: 'Profile Management'
        },
        errorPage: {
            title: 'Accounts Rewards Unavailable',
            description: "We're having trouble retrieving\nyour information",
            tryAgain: 'Please try again later.',
            noCertificates: 'There are no certificates that match that certificate number.\nPlease check the number and try again.'
        },
        faqs: {
            faqLinkText: 'Rewards FAQs',
            description: '*Purchases subject to credit approval. See <a>Rewards Program Terms</a> for details.',
            cathaySnapshotDescription: '*Purchases subject to credit approval. See <a>Credit Rewards Terms</a> for details.',
            suncountrySnapshotDescription: '*See <a>Credit Rewards Terms</a> for details.',
            verizonSnapshotDescription: 'Excluding bill payments. \n*Purchases subject to credit approval. See <a>Rewards Program Terms</a> for details.',
            jcrewFaqsSubHeader: 'See your <a>J.Crew Tier Level Status and all cardmember perks</a>',
            virginDescription: '*See <a>Credit Rewards Terms</a> for details.\n\nIf you have a return on your Virgin Red Rewards Card, you may see negative points in one or more categories. Any new points you earn with your card in that category will be first applied to the negative balance in the same category. Points will be added to your Virgin Red Rewards Program Account after your point balance within that category becomes positive.\n\nThis card is issued by Synchrony Bank pursuant to a license by Mastercard International Incorporated. Mastercard and the circles design are registered trademarks of Mastercard International Incorporated. The Contactless Indicator mark, consisting of four graduating arcs, is a trademark owned by and used with permission of EMVCo, LLC.',
            cathayDescription: '*Purchases subject to credit approval. See <a>Credit Rewards Terms</a> for details.\n\nThis card is issued by Synchrony Bank pursuant to a license by Mastercard International Incorporated. Mastercard and the circles design are registered trademarks of Mastercard International Incorporated. The Contactless Indicator mark, consisting of four graduating arcs, is a trademark owned by and used with permission of EMVCo, LLC.',
            verizonDescription: 'Excluding bill payments. \n\n*Purchases subject to credit approval. See <a>Rewards Program Terms</a> for details.\n\nThe Verizon Visa Signature® Card is issued by Synchrony Bank pursuant to a license from Visa U.S.A., Inc. The Contactless Indicator mark, consisting of four graduating arcs, is a trademark owned by and used with permission of EMVCo, LLC.',
            suncountryDescription: '*See <a>Credit Rewards Terms</a> for details.\n\nNote: Returns may result in a negative points balance. Any new points earned will be applied towards that balance.\n\nThe Sun Country Airlines Visa Signature® Card is issued by Synchrony Bank pursuant to a license from Visa U.S.A., Inc. The Contactless Indicator mark, consisting of four graduating arcs, is a trademark owned by and used with permission of EMVCo, LLC.',
            jcpenneyDescription: '*Purchases subject to credit approval. See <a>Rewards Program Terms</a> for details.',
            walgreensDescription: '*Purchases subject to credit approval. See <a>Rewards Program Terms</a> for details.\n\nThis card is issued by Synchrony Bank pursuant to a license by Mastercard International Incorporated. Mastercard and the circles design are registered trademarks of Mastercard International Incorporated. The Contactless Indicator mark, consisting of four graduating arcs, is a trademark owned by and used with permission of EMVCo, LLC.'
        },
        certificateHistoryTab: {
            amount: 'Certificate \nAmount',
            certificate: 'Certificate',
            status: 'Status',
            certificateNumber: 'Certificate Number',
            date: 'Date',
            searchCertNum: 'Search Certificate Number',
            redeemed: 'Redeemed',
            expired: 'Expired'
        },
        selectDropdown: {
            sortBy: 'Sort by',
            newestDate: 'Date - Newest',
            oldestDate: 'Date - Oldest',
            redeemedStatus: 'Status - Redeemed',
            expiredStatus: 'Status - Expired',
            lowestAmount: 'Amount - Lowest',
            highestAmount: 'Amount - Highest'
        },
        fullDetailsPage: {
            certificateHistory: 'Certificate History',
            myRewardsMilestones: 'My Rewards milestones',
            yourRewardsMilestones: 'Your Rewards milestones',
            howToEarnPointsHeader: 'How to earn points',
            jCrewHowToEarnPointsHeader: 'How to earn points for J.Crew and J.Crew Factory purchases',
            virginHowToEarnPointsHeader: 'How to earn points*',
            cathayHowToEarnPointsHeader: 'How to earn Asia Miles*',
            sunCountryHowToEarnPointsHeader: 'Your Sun Country Earnings',
            verizonHowToEarnPointsHeader: 'How to earn Verizon Dollars',
            exclusionsApply: 'Exclusions apply',
            certificate: {
                expiringSoon: 'EXPIRING SOON',
                select: 'SELECT',
                useBy: 'Use by'
            },
            athome: {
                DUAL_CARD: {
                    redemptionDisclaimer: 'Redeem your Rewards Certificates and pay any remaining balance with your At Home Insider Perks® Mastercard® to earn points toward your next certificate.',
                    legalInformation: 'The At Home Insider Perks® Mastercard and At Home Insider Perks® Boss Mastercard are issued by Synchrony Bank pursuant to a license by Mastercard International Incorporated. Mastercard and the circles design are registered trademarks of Mastercard International Incorporated.'
                },
                PRIVATE_LABEL: {
                    redemptionDisclaimer: 'Redeem your Rewards Certificates and pay any remaining balance with your At Home Insider Perks® Credit Card to earn points toward your next certificate.'
                },
                totalPointsSavedYTD: 'TOTAL SAVED IN REDEEMED REWARDS CERTIFICATES THIS YEAR',
                totalPointsRedeemedYTD: 'TOTAL POINTS USED FOR REWARD CERTIFICATES THIS YEAR',
                // eslint-disable-next-line sonarjs/no-duplicate-string
                totalPointsEarnedYTD: 'TOTAL POINTS EARNED THIS YEAR',
                printCheckoutModal: 'Simply print out or show digital Rewards Certificates to an associate or enter code online at checkout.*'
            },
            tjx: {
                DUAL_CARD: {
                    redemptionDisclaimer: 'Redeem your Rewards Certificates and pay any remaining balance with your TJX Rewards credit card to earn points toward your next certificate.'
                },
                PRIVATE_LABEL: {
                    redemptionDisclaimer: 'Redeem your Rewards Certificates and pay any remaining balance with your TJX Rewards credit card to earn points toward your next certificate.'
                },
                totalPointsSavedYTD: 'TOTAL SAVED THIS YEAR IN REWARDS',
                totalPointsRedeemedYTD: 'TOTAL POINTS REDEEMED THIS YEAR',
                totalPointsEarnedYTD: 'TOTAL POINTS EARNED THIS YEAR',
                printCheckoutModal: 'Simply print out or show digital Rewards Certificates at checkout.'
            },
            hft: {
                PRIVATE_LABEL: {
                    redemptionDisclaimer: 'Redeem your Rewards Certificates and pay any remaining balance with your Harbor Freight Tools Credit Card to earn points toward your next certificate.'
                },
                totalPointsSavedYTD: 'TOTAL SAVED IN REDEEMED REWARDS CERTIFICATES THIS YEAR',
                totalPointsRedeemedYTD: 'TOTAL POINTS USED FOR REWARD CERTIFICATES THIS YEAR',
                totalPointsEarnedYTD: 'TOTAL POINTS EARNED THIS YEAR',
                printCheckoutModal: 'Simply print out or show digital Rewards Certificates to an associate or enter code online at checkout.*'
            },
            removeTimeFromList: 'May take up to 72 hours to be removed from this list.',
            rewards: 'Rewards',
            printCheckout: 'Simply print out or show digital Rewards Certificates at checkout',
            useRewardsNow: 'Redeem your Rewards Certificates',
            print: 'print',
            selectAll: 'SELECT ALL',
            unSelectAll: 'UN-SELECT ALL',
            myRewardsCertificates: 'My Rewards Certificates',
            yourRewardsCertificates: 'Your Rewards Certificates',
            viewAllCertificates: 'VIEW ALL REWARDS CERTIFICATES',
            viewPrint: 'VIEW/PRINT',
            viewRewardCertificates: 'View Reward Certificates'
        },
        earnings: {
            earningsFromLastStatement: 'Your earnings from your last statement'
        },
        cathayEarnings: {
            yourCathayEarnings: 'Your Cathay Asia Miles earnings'
        },
        jCrewEarnings: {
            noAdjustments: 'Currently no adjustments on your J.Crew Rewards',
            yourJcrewEarnings: 'Your J.Crew Passport earnings'
        },
        sunCountryEarnings: {
            yourSunCountryEarnings: 'Your Sun Country earnings'
        },
        verizonEarnings: {
            yourVerizonEarnings: 'Your Verizon earnings',
            verizonEarningsSubtitle: 'Earn up to 4% on all of your favorite purchases with your Verizon Visa® Card*'
        },
        virginEarnings: {
            yourVirginEarnings: 'Your Virgin Red earnings'
        },
        jcrew: {
            perks: {
                perksHeader: 'A few special perks for cardmembers',
                freeStandardShippingTitle: 'Free shipping',
                freeStandardShippingDescription: 'Free standard shipping at J.Crew and J.Crew Factory',
                birthdaySurprisesTitle: 'Birthday',
                birthdaySurprisesDescription: '$25 to spend at J.Crew and J.Crew Factory',
                bonusPointsDaysTitle: 'FREE STANDARD ALTERATIONS',
                bonusPointsDaysDescription: 'On full priced merchandise at J.Crew'
            }
        },
        virgin: {
            perks: {
                perksHeader: 'A few special perks for cardholders*',
                extraNightTitle: 'Stay an extra night free',
                extraNightDescription: 'Buy two nights, get one free from Virgin Hotels on an annual basis',
                flyAndEarnTitle: 'FLY WITH US AND EARN',
                flyAndEarnDescription: 'Receive 25 Tier Points for spending $2,500/mo, max of 50/mo.',
                earnBonusPointsTitle: 'EARN BONUS POINTS',
                earnBonusPointsDescription: 'Earn 2,500 bonus points for up to 4 Authorized Users added.'
            }
        },
        suncountry: {
            perks: {
                perksHeader: 'A few special perks for cardholders',
                earnOffOnSuitcaseTitle: '50% OFF FIRST BAG',
                earnOffOnSuitcaseDescription: 'Save 50% on first bags for you and your companions traveling on the same itinerary.',
                flyAndEarnTitle: '50% OFF SEAT SELECTIONS',
                flyAndEarnDescription: 'Save 50% on your seat selection to make every flight more comfortable.',
                earnBonusPointsTitle: 'ANNIVERSARY BONUS',
                earnBonusPointsDescription: 'Earn 10,000 bonus points when you spend $10,000+ annually.'
            }
        },
        mocks: {
            accountEnding: 'Account ending in {{accountLast4}}',
            availableToSpend: 'Available to spend',
            cardAccountEnding: 'Card for account ending in {{accountLast4}}',
            currentBalance: 'Current Balance',
            environment: 'Choose an Environment',
            makeAPayment: 'Make a Payment',
            paymentDueDate: 'Payment Due Date',
            rewards: 'REWARDS',
            totalMinimumPayment: 'Total Minimum Payment',
            rewardsFooterButton: 'VIEW FULL REWARDS DETAILS'
        },
        modal: {
            modalTitle: 'Rewards Snapshot',
            rewardsFooter: 'VIEW FULL REWARDS DETAILS',
            header: {
                text: 'Rewards Snapshot'
            },
            footer: {
                closeButton: 'Close'
            },
            rewards: {
                currentPoints: 'Current points',
                earned: 'Your Rewards earned',
                nextCertificate: '${{amount}} certificate',
                currentRewards: 'Current Rewards\nCertificate balance',
                myProgress: 'My Rewards progress',
                yourProgress: 'Your Rewards progress'
            }
        },
        shopMore: {
            earnPoints: {
                default: 'Once a Rewards Certificate is redeemed, it will be displayed here.',
                aeoutfitters: 'Check out our extra-special perks, just for Cardmembers.',
                athome: 'Earn points toward your next Rewards Certificate, then check back here to redeem.',
                cathay: "Check out our extra-special perks, just for Cardmembers.",
                jcpenney: "Check out our extra-special perks, just for Cardmembers.",
                jcrew: "Check out our extra-special perks, just for Cardmembers.",
                suncountry: 'Check out our extra-special perks, just for Cardmembers.',
                tjx: "Keep shopping with your TJX Rewards credit card to earn points towards your next Rewards Certificate. It's the only way to save even more across your favorite stores!",
                virgin: "Check out our extra-special perks, just for Cardmembers.",
                onepaywalmart: "Check out our extra-special perks.",
                dicks: "Check out our extra-special perks, just for Cardmembers.",
                verizon: "Check out our extra-special perks, just for Cardmembers.",
                walgreens: "Check out our extra-special perks, just for Cardmembers.",
                hft: 'Earn points toward your next Rewards Certificate, then check back here to redeem.'
            },
            cathayButtonText: 'Go to Cathay Rewards',
            jCrewButtonText: 'Go to J.Crew Rewards',
            suncountryButtonText: 'GO TO SUN COUNTRY REWARDS',
            verizonButtonText: 'GO TO VERIZON REWARDS',
            virginButtonText: 'Learn More',
            walgreensButtonText: 'GO TO MYWALGREENS REWARDS',
            earnMoreRewards: 'Earn more rewards',
            withYour: 'with your',
            onepaywalmartPlccText: 'View your available rewards today!'
        },
        drawerHeader: {
            subtitle: {
                account: 'Account ending in {{accountLast4}}'
            }
        },
        drawerActionButton: {
            aeoutfittersDrawerActionButtonText: 'GO TO REAL REWARDS',
            jcpenneyDrawerActionButtonText: 'GO TO JCPENNEY REWARDS',
            onepaywalmartDrawerActionButtonText: 'GO TO ONEPAY REWARDS',
            dicksDrawerActionButtonText: 'GO TO SCOREREWARDS'
        },
        error: {
            uiComponent: 'Not Available'
        },
        rewardsBanner: {
            altText: '{{client}} banner'
        },
        viewPrintModal: {
            and: 'and',
            atHomeViewPrint: 'Certificates can be used in store or online at',
            digitalCopy: 'This is a digital copy of the certificate you received with your credit card statement.',
            issueDate: 'Issue Date',
            presentPurchase: '*Present at time of purchase.',
            tjxDisclaimer: 'Not accepted at Marshalls or HomeSense in Canada.',
            athomeDisclaimer: 'Redeemed Rewards Certificates may take up to 72 hours to be removed from this list.',
            tjxViewPrint: 'Certificates can be used like cash within our family of stores or online at',
            hftViewPrint: 'Certificates can be used within our stores or online at',
            hftDisclaimer: 'Redeemed Rewards Certificates may take up to 72 hours to be removed from this list.',
            redeemAt: '<p>Redeem at:</p>',
            rewardsCertificate: 'Rewards Certificate',
            viewRewardCertificate: 'View Reward Certificate',
            viewRewardsProgram: 'View <a>Rewards Program Terms</a> for details'
        }
    }
};
export default englishTranslation;
